import axios from 'axios';
import { useQuery } from 'react-query';
import { useApi } from 'hooks';

interface StreetViewMetadata {
  status: string;
  pano_id?: string;
  [key: string]: any;
}

const fetchStreetViewStatus = async (
  api: ReturnType<typeof useApi>,
  lat: number,
  lng: number,
  exteriorOnly: boolean,
): Promise<StreetViewMetadata> => {
  const params = new URLSearchParams({
    key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
    location: `${lat},${lng}`,
  });

  if (exteriorOnly) {
    params.append('source', 'outdoor');
  }

  const response = await axios.get<StreetViewMetadata>(
    `https://maps.googleapis.com/maps/api/streetview/metadata?${params.toString()}`,
  );

  if (!response) {
    throw new Error('Failed to fetch Street View status');
  }

  return response.data;
};

export const useCheckStreetViewStatus = (
  lat: number,
  lng: number,
  exteriorOnly: boolean = true,
) => {
  const api = useApi();

  return useQuery(
    ['streetViewStatus', lat, lng, exteriorOnly],
    () => fetchStreetViewStatus(api, lat, lng, exteriorOnly),
    {
      enabled: !!lat && !!lng,
      retry: 1, // Retry once if the request fails
      staleTime: 5 * 60 * 1000, // Cache the result for 5 minutes
    },
  );
};
